import { useEffect, useRef } from "react";

/**
 * Poll `fn` on an interval without resetting when the callback identity changes.
 * Mantine's useInterval restarts (and can stall) whenever `fn` is a new closure.
 */
export function usePolling(
  fn,
  { enabled = true, intervalMs = 5000, invokeImmediately = false } = {}
) {
  const fnRef = useRef(fn);

  useEffect(() => {
    fnRef.current = fn;
  });

  useEffect(() => {
    if (!enabled) return undefined;
    if (invokeImmediately) fnRef.current();
    const id = window.setInterval(() => fnRef.current(), intervalMs);
    return () => window.clearInterval(id);
  }, [enabled, intervalMs, invokeImmediately]);
}
